module.exports = __webpack_public_path__ + "static/media/video-icon2.10dd2e58.svg";